import PQueue from 'p-queue';

import { loadImages } from './image-loading';

export interface TaskResult {
  id: string;
  events: Event[];
}

interface ExecutorTask {
  getExecutor(): () => Promise<TaskResult>;
}

class ImagePreloaderTask implements ExecutorTask {
  public constructor(
    private readonly id: string,
    private readonly urls: string[]
  ) {}

  public getExecutor(): () => Promise<TaskResult> {
    return async () => {
      const events = await loadImages(this.urls);
      return {
        id: this.id,
        events
      }; // all images are loaded
    };
  }
}

// concurrency which will be overridden from outside by config
const CONCURRENCY = 1;

class ImagePreloader {
  private readonly queue = new PQueue({ concurrency: CONCURRENCY });

  public updateConcurrency(value: number): void {
    this.queue.concurrency = value;
  }

  public async add(id: string, urls: string[], priority = 0): Promise<void | TaskResult> {
    const task = new ImagePreloaderTask(id, urls);
    return this.queue.add(task.getExecutor(), { priority });
  }

  public clear(): void {
    this.queue.clear();
  }
}

export default new ImagePreloader();
